import { createGenericStore } from '../store/genericStore';
import { UserInvite } from './types';

export const useOrgUserInviteStore = createGenericStore<UserInvite>();
